const Title = () => {
  return (
    <div className="flex w-full items-end justify-center -mt-16">
      <div className="flex sm:w-[1153px]">
        <h1 className="text-4xl sm:text-6xl font-bold sm:h-20 text-center">
          The world&apos;s most powerful{" "}
          <span className="bg-gradient-to-r from-brand-purple to-brand-blue text-transparent bg-clip-text h-20 font-bold">
            social digital privacy software
          </span>
        </h1>
      </div>
    </div>
  );
};

export default Title;
